/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * Brand constants
 */
export const BrandLabel = {
  CL: "Community Leaders",
  MSA: "Learn Student Ambassadors",
  RD: "Regional Directors",
  MVP: "Most Valuable Professionals",
  AMPLIFY: "Amplify",
};

export const YES = "Yes";
